export const CALENDAR_UPDATED_AT = 'CALENDAR_UPDATED_AT';

export function setCalendarUpdatedAt(homeId, updatedAt) {
    return {
        type: CALENDAR_UPDATED_AT,
        homeId,
        updatedAt
    };
}
